import { render, staticRenderFns } from "./TruckSupply.vue?vue&type=template&id=3c8a323c&"
import script from "./TruckSupply.vue?vue&type=script&lang=js&"
export * from "./TruckSupply.vue?vue&type=script&lang=js&"
import style0 from "./TruckSupply.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports